import Vue from "vue";
import Vuex from "vuex";

const Petitioner = {
    namespaced: true,
    state: {
        petitioner: {
            title: null,
            nature: null,
            firstName: null,
            lastName: null,
            corporationName: null,
            corporationSiret: null,
            corporationAgentTitle: null,
            corporationAgent: null,
            addressNum: null,
            addressExt: null,
            addressType: null,
            addressPostalCode: null,
            phone: null,
            phoneIndicative: null,
            email: null,
            isbeneficiaire: false,
        },
        beneficiary: {
            title: null,
            nature: null,
            firstName: null,
            lastName: null,
            corporationName: null,
            corporationSiret: null,
            corporationAgentTitle: null,
            corporationAgent: null,
            addressNum: null,
            addressExt: null,
            addressType: null,
            addressPostalCode: null,
            phone: null,
            phoneIndicative: null,
            email: null,
        }
    },
    actions: {
        addPetitionner(context, petitioner) {
            if (petitioner.addressNum === "") {
                petitioner.addressNum = null;
            }
            
            return Vue.axios.post(window.urlapi + "petitioner", petitioner)
                .then(response => {
                if (response.data.success === false) {
                    throw new Error(response.data.message || "Erreur lors de la création du pétitionnaire");
                }
                return response.data.data;
                })
                .catch(error => {
                console.error("Erreur dans addPetitionner:", error);
                throw error;
            });
        },
        updatePetitionner(context, petitioner) {
            if (petitioner.addressNum == "") {
                petitioner.addressNum = null;
            }
            return new Promise((resolve, reject) => {
                Vue.axios.put(window.urlapi + "petitioner/" + petitioner.id, petitioner).then(
                    response => {
                        if (response.data.success == true) {
                            resolve(response.data.data);
                        }
                    },
                );
            })
        },
        initPetitioner(context, isBeneficiary) {
            return new Promise((resolve, reject) => {
                let object = {
                    title: null,
                    nature: "Entreprise",
                    firstName: null,
                    lastName: null,
                    corporationName: null,
                    corporationSiret: null,
                    corporationAgentTitle: null,
                    corporationAgent: null,
                    addressNum: null,
                    addressExt: null,
                    addressType: null,
                    addressPostalCode: null,
                    phone: null,
                    phoneIndicative: null,
                    email: null,
                }
                if (isBeneficiary) {
                    context.commit("SETBENEFICIARY", object);
                } else {
                    object.isbeneficiaire = false;
                    context.commit("SETPETITIONER", object);
                }
                resolve();
            })
        },
        setPetitioner(context, petitioner) {
            return new Promise((resolve, reject) => {
                context.commit("SETPETITIONER", petitioner);
                resolve();
            })
        },
        setBeneficiary(context, petitioner) {
            return new Promise((resolve, reject) => {
                context.commit("SETBENEFICIARY", petitioner);
                resolve();
            })
        },


        getPetitionner(context, id) {
            Vue.axios.get(window.urlapi + "petitioner/" + id).then(
                response => {
                    if (response.data.success == true) {
                        resolve(response.data.data);
                    }
                },
            );
        }
    },
    mutations: {

        SETBENEFICIARY: (state, petitioner) => {
            state.beneficiary = petitioner
        },
        SETPETITIONER: (state, petitioner) => {
            state.petitioner = petitioner
        },
    },
    getters: {
        petitioner: state => {
            return state.petitioner;
        },
        beneficiary: state => {
            return state.beneficiary;
        },
    },
    modules: {}
};

export default Petitioner;